import React from "react";
import {
    Modal,
    Row,
    Col,
    Input,
    Radio,
    message,
    DatePicker,
    Select
} from "antd";
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import { getEmployeeCode } from '../../common/getEmployeeCode';
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import moment from "moment";

const { TextArea } = Input;
const { Option } = Select;
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';
const typeInConfig = {
    add: {
        title: '新建交接任务',
        message: '新建成功',
    },
    edit: {
        title: '修改交接任务',
        message: '修改成功',
    },
};

class Update extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading: false,
            saveParams: {},
            fteData: [],
            config:{}
        };
    }
    componentDidMount(){
        sessionStorage.curEmployeeCode && getEmployeeCode().then(res => this.setState({employeeCode : res.data.user.employeeCode}) )
    }

    genConfig = (type) => {
        return {
            ...typeInConfig[type],
            [type]: true
        };
    };

    show = (record, type) => {
        const saveParams = {};
        const config = this.genConfig(type);
        if (config.edit) {
            const {
                investigationName,
                handoverReason, 
                planHandoverEndTime, 
                staffHandoverId,
                // 交接PM
                handoverUserCode,
                handoverUserName,
                // 接收PM 
                receiveUserId,
                receiveUserCode,
                receiveUserName, 
                // 交接PM确认人
                handoverConfirmUserId,
                handoverConfirmUserCode,
                handoverConfirmUserName,
                // 接收PM确认人
                receiveConfirmUserId,
                receiveConfirmUserCode,
                receiveConfirmUserName,
                createType// WEB_CREATE 列表新建, IMPORT_DATA 导入数据
            } = record;
            saveParams.investigationName = investigationName;
            saveParams.createType = createType;
            saveParams.handoverReason = handoverReason;
            saveParams.planHandoverEndTime = planHandoverEndTime;
            saveParams.staffHandoverId = staffHandoverId;
            saveParams.receiveUserId = receiveUserId;
            saveParams.handoverUserName = (handoverUserName && handoverUserCode) ? `${handoverUserName}[${handoverUserCode}]`:'';
            saveParams.receiveUserName = (receiveUserName && receiveUserCode) ? `${receiveUserName}[${receiveUserCode}]`:'';
            saveParams.handoverConfirmUserId = handoverConfirmUserId;
            saveParams.handoverConfirmUserName = (handoverConfirmUserName && handoverConfirmUserCode) ? `${handoverConfirmUserName}[${handoverConfirmUserCode}]`:undefined;
            saveParams.receiveConfirmUserId = receiveConfirmUserId;
            saveParams.receiveConfirmUserName = (receiveConfirmUserName && receiveConfirmUserCode) ? `${receiveConfirmUserName}[${receiveConfirmUserCode}]`:undefined;
            
        }else{
            saveParams.planHandoverEndTime = moment().add(15,'days').format('YYYY-MM-DD')
        }
        this.setState({
            visible: true,
            saveParams,
            config
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key) => {
        const { saveParams } = this.state;
        
        switch (key) {
            case 'receiveUser': 
            case 'handoverConfirmUser':
            case 'receiveConfirmUser':
            {
                const { value: id, text: name } = value;
                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;
                this.setState({ saveParams });
                break;
            }
            case 'investigation':
            {
                const { value: id, text: name, userCompellation, employeeCode } = value;
                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;
                saveParams.userCompellation = userCompellation;
                saveParams.pmEmployeeCode = employeeCode;
                this.setState({ saveParams });
                break;
            }
            case "proCompTime": {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.queryFte();
                });
            }
            default:
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
        }
    }

    handleSubmit = () => {
        const { saveParams, config, src } = this.state;
        const { receiveUserName, handoverReason, investigationName } = saveParams;
        if(config.add && src == 'pmTransfer' && !investigationName){
            return message.warning("请选择项目简称");
        }

        if (!receiveUserName) {
            return message.warning("请选择接收PM");
        }
        if (!handoverReason) {
            return message.warning("请输入交接原因");
        }

        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.saveStaffHandover,
            data: saveParams,
            dataType: "json",
            doneResult: () => {
                message.success(config.message);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.reload();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, saveParams, config, employeeCode = null } = this.state;
        const { investigationName, handoverUserName, userCompellation, pmEmployeeCode } = saveParams;
        const { userName, curRole }  = sessionStorage;
        const { src } = this.props;
        const mastStart = (<span style={{color:'red'}}>*</span>)
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                width={450}
                confirmLoading={loading}
            >   
                {
                    config.edit && 
                    <Row>
                        <Col span={7} style={{ textAlign: 'right' }}>项目简称：</Col>
                        <Col span={16}>
                            {investigationName}
                        </Col>
                    </Row>
                }
                {
                    config.add && src == 'pmTransfer' &&
                    <Row>
                        <Col span={7} style={{ textAlign: 'right' }}>{mastStart}项目简称：</Col>
                        <Col span={16}>
                            <SearchRetrieve
                                keyword='investigationName'
                                style={{ width: 200 }}
                                placeholder="输入项目简称检索"
                                value={investigationName}
                                params={{ offset: 1, limit: 20 }}
                                url={API_URL.investigation.queryMainPmUserByLeaderId}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                onChange={value => this.handleChange(value, 'investigation')}
                            />
                        </Col>
                    </Row>
                }
                
                <Row>
                    <Col span={7} style={{ textAlign: 'right' }}>交接PM：</Col>
                    <Col span={16}>
                        { config.add && src == 'pmTransfer' ? ( !investigationName ? '' : `${userCompellation}[${pmEmployeeCode}]` ) : config.edit ? handoverUserName : `${userName}[${employeeCode}]` }
                    </Col>
                </Row>
                <Row>
                    <Col span={7} style={{ textAlign: 'right' }}>{mastStart}接收PM：</Col>
                    <Col span={16}>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 200 }}
                            placeholder="输入姓名/工号检索"
                            value={saveParams.receiveUserName}
                            params={{ limit: 20,needPosition:'TRUE' }}
                            url={API_URL.execute.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'receiveUser')}
                        />
                    </Col>
                </Row>
                <Row >
                    <Col span={7} style={{ textAlign: 'right' }}>{mastStart}交接原因：</Col>
                    <Col span={16}>
                        <Input
                            value={saveParams.handoverReason}
                            placeholder="请输入"
                            style={{ width: 200 }}
                            onChange={e => this.handleChange(e.target.value, 'handoverReason')}
                        />
                    </Col>
                </Row>
                {
                    saveParams.createType !== 'IMPORT_DATA' && 
                    <Row >
                        <Col span={7} style={{ textAlign: 'right' }}>预计交接结束日期：</Col>
                        <Col span={16}>
                            <DatePicker
                                format={dateFormat}
                                style={{ width: 200 }}
                                value={saveParams.planHandoverEndTime ? moment(saveParams.planHandoverEndTime) : null}
                                onChange={(date, dateString) => this.handleChange(dateString, 'planHandoverEndTime')}
                            />
                        </Col>
                    </Row>
                }
                {
                    (curRole == 'BO' || curRole == 'CSAL' || curRole == 'PML') && saveParams.createType == 'IMPORT_DATA' &&
                    <Row>
                    <Col span={7} style={{ textAlign: 'right' }}>{ !config.edit &&  mastStart}交接PM确认人：</Col>
                    <Col span={16}>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 200 }}
                            placeholder="输入姓名/工号检索"
                            value={saveParams.handoverConfirmUserName}
                            params={{ limit: 20 }}
                            url={API_URL.execute.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'handoverConfirmUser')}
                        />
                    </Col>
                </Row>
                }
                {
                    (curRole == 'BO' || curRole == 'CSAL' || curRole == 'PML') && saveParams.createType == 'IMPORT_DATA' &&
                    <Row>
                    <Col span={7} style={{ textAlign: 'right' }}>{ !config.edit &&  mastStart}接收PM确认人：</Col>
                    <Col span={16}>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 200 }}
                            placeholder="输入姓名/工号检索"
                            value={saveParams.receiveConfirmUserName}
                            params={{ limit: 20 }}
                            url={API_URL.execute.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'receiveConfirmUser')}
                        />
                    </Col>
                </Row>
                }
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/user/transfer/PMUpdate.js